import { c as _c } from "react/compiler-runtime";
import React, { forwardRef } from 'react';
import MUITypography from '@mui/material/Typography';
import { useTheme } from '../../utils/useTheme';
import { getToken } from '../theme/tokens/getToken';
import { type TypographyProps, typographyColorTokenPaths } from './types';
const Typography = forwardRef<HTMLHeadingElement, TypographyProps>((t0, ref) => {
  const $ = _c(14);
  let children;
  let color;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      variant: t1,
      color,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = color;
    $[3] = props;
    $[4] = t1;
  } else {
    children = $[1];
    color = $[2];
    props = $[3];
    t1 = $[4];
  }
  const variant = t1 === undefined ? "body1" : t1;
  const theme = useTheme();
  let t2;
  if ($[5] !== color || $[6] !== theme) {
    t2 = color != null ? getToken(theme, typographyColorTokenPaths[color]) : undefined;
    $[5] = color;
    $[6] = theme;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const resolvedColor = t2;
  let t3;
  if ($[8] !== children || $[9] !== props || $[10] !== ref || $[11] !== resolvedColor || $[12] !== variant) {
    t3 = <MUITypography variant={variant} color={resolvedColor} {...props} ref={ref}>{children}</MUITypography>;
    $[8] = children;
    $[9] = props;
    $[10] = ref;
    $[11] = resolvedColor;
    $[12] = variant;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
});
export default Typography;
export { Typography };
export type { Variant as TypographyVariant, TypographyProps } from './types';